import { BalanceItem, CelerBalance } from '@/state/reducers/balanceSlice';
import { getAssetName } from '@/utils/symbolMapping';
import BigNumber from 'bignumber.js';
import { getEnvironment } from './environmentHelper';

export const aggregateBalances = (balances: Record<string, Record<string, BalanceItem>>) => {
    const aggregatedBalances = {} as Record<string, BalanceItem>;
    const allBalanceItems = Object.values(balances).flatMap(Object.values);

    for (const balanceItem of allBalanceItems) {
        const { currency, notionalCurrency, netPosition, notionalNetPosition } = balanceItem;
        if (!(currency in aggregatedBalances)) {
            aggregatedBalances[currency] = {
                currency,
                netPosition: 0,
                notionalNetPosition: 0,
                notionalCurrency,
                settlementDate: 'AGGR'
            };
        }

        aggregatedBalances[currency].netPosition = BigNumber(aggregatedBalances[currency].netPosition)
            .plus(netPosition)
            .toNumber();
        aggregatedBalances[currency].notionalNetPosition = BigNumber(aggregatedBalances[currency].netPosition)
            .plus(notionalNetPosition)
            .toNumber();
    }

    const balanceList = Object.values(aggregatedBalances);
    balanceList.sort((a: any, b: any) => (a.notionalNetPosition > b.notionalNetPosition ? -1 : 1));

    return balanceList;
};

export const sortBalances = (aggregatedBalances: BalanceItem[]) => {
    const temp: BalanceItem[] = [...aggregatedBalances].map((balance) => ({
        ...balance,
        currency: getAssetName(balance.currency)
    }));
    // GCX-1060 UAT and DEMO will default have 100_000 USD in balance
    if (['uat', 'demo'].includes(getEnvironment())) {
        const usdIndex = temp.findIndex((balance) => balance.currency === 'USD');
        if (usdIndex !== -1) {
            temp[usdIndex].netPosition = BigNumber(temp[usdIndex].netPosition).plus(100_000).toNumber();
        } else {
            temp.push({
                currency: 'USD',
                netPosition: 100_000,
                notionalCurrency: 'USD',
                notionalNetPosition: 100_000,
                settlementDate: 'AGGR'
            });
        }
    }

    temp.sort(balanceSort);
    return temp;
};

export const balanceSort = (a: CelerBalance, b: CelerBalance) => {
    if (a.currency < b.currency) return -1;
    if (a.currency > b.currency) return 1;
    return 0;
};
